import {SummaryModel} from '../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../common/entity/permissions.model';
import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';


export class BankCheckSummaryModel implements SummaryModel{
    id: number;
    permissions: PermissionsModel;
    number: string;
    from: string;
    status: LovValueSummary;
}
